import { SiteProduct } from "./resolvers"

/**
 * Inline-style product card shared by ProductShowcase and ProductCard.
 * Mirrors the skeleton styling of the placeholder states so the switch from
 * placeholder to real data does not shift the layout.
 */
export function ProductTile({
  product,
  ctaLabel,
  layout = "vertical",
  showDescription = true,
}: {
  product: SiteProduct
  ctaLabel: string
  layout?: "horizontal" | "vertical"
  showDescription?: boolean
}) {
  const image = product.thumbnail ? (
    // Thumbnails come from the Medusa Store API (tenant-uploaded media).
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={product.thumbnail}
      alt={product.title}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  ) : (
    <span style={{ color: "#9ca3af", fontSize: 13 }}>Product</span>
  )

  return (
    <a
      href={product.href}
      style={{
        display: "flex",
        flexDirection: layout === "horizontal" ? "row" : "column",
        gap: 16,
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        overflow: "hidden",
        background: "#fff",
        textDecoration: "none",
        color: "inherit",
        alignItems: layout === "horizontal" ? "center" : "stretch",
        padding: layout === "horizontal" ? 20 : 0,
      }}
    >
      <div
        style={{
          ...(layout === "horizontal"
            ? { width: 200, flexShrink: 0 }
            : { width: "100%" }),
          aspectRatio: "1/1",
          background: "#f3f4f6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {image}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          flex: 1,
          ...(layout === "vertical" ? { padding: 16 } : {}),
        }}
      >
        <div style={{ fontWeight: 700, color: "#111827" }}>{product.title}</div>
        {showDescription && product.description && (
          <div style={{ fontSize: 14, color: "#6b7280" }}>
            {product.description}
          </div>
        )}
        <div
          style={{
            marginTop: "auto",
            paddingTop: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {product.price}
          </span>
          <span
            style={{
              padding: "6px 12px",
              background: "var(--site-accent, #7c3aed)",
              color: "#fff",
              borderRadius: 6,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            {ctaLabel}
          </span>
        </div>
      </div>
    </a>
  )
}
